module.exports = __webpack_public_path__ + "img/coblow.69360001.jpg";